<div class="modal-header">
  <h4 class="modal-title">Upload Document</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-group">
    <!--    <span style="font-weight: bold">Program:</span>-->
    <p>Select program for uploaded file(s):</p>
    <ul>
      <li *ngFor="let file of files">{{file.name}}</li>
    </ul>
    <div>
      <label for="program" style="font-weight: bold">Program:</label>
      <input class="form-control" type="text" name="program" [(ngModel)]="program" id="program"/>
    </div>
  </div>
</div>
<div class="modal-footer">
  <span style="color: red;">{{errorMessage}}</span>
  <button type="button" class="btn btn-outline-light" (click)="modal.dismiss()">Cancel</button>
  <button type="button" class="btn btn-outline-dark" (click)="processProgram()">Save</button>
</div>
